import { useContext } from 'react';

import { type Theme, THEME } from '../../constants/theme';
import { ThemeContext } from '../contexts/theme-context';

type UseThemeResult = [Theme, () => void, boolean];

export function useTheme(): UseThemeResult {
    const { theme, setTheme } = useContext(ThemeContext);

    const toggleTheme = () => {
        const newTheme = theme === THEME.light ? THEME.dark : THEME.light;

        setTheme?.(newTheme);
    };

    return [theme || THEME.light, toggleTheme, theme === THEME.dark];
}
